import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _omit from 'lodash/omit';
import { reduxFormPropTypes } from 'constants/propTypes';
import { shouldShowError } from 'helpers/page-utils';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import { getOffsetDaysOfWeek } from 'helpers/intl-fns';
import InputError from '../InputError/InputError';
import './DayOfWeekPicker.scss';

const messages = defineMessages({
  dowShort: {
    id: 'components.form.day-of-week-picker.dow-short',
    defaultMessage: '{dateTime, date, dow-short}',
  },
});

const DEFAULT_VALUE_MAP = {
  Mo: false,
  Tu: false,
  We: false,
  Th: false,
  Fr: false,
  Sa: false,
  Su: false,
};

const changeWeekdayBoxState = (valueMap, onChange, { value }) =>
  onChange({
    ...valueMap,
    [value]: !valueMap[value],
  });

const DayOfWeekPicker = ({ input: { value, onChange }, meta, disabled, startWeekOn, className, ...restProps }) => {
  const valueMap = value || DEFAULT_VALUE_MAP;
  const daysOfWeek = getOffsetDaysOfWeek(startWeekOn);
  const hasError = shouldShowError(meta);
  const filteredProps = _omit(restProps, ['dispatch', 'hasError']);

  return (
    <div className={withMods('day-of-week-picker', 'grid grid--flush', className)} {...filteredProps}>
      <div className={withMods('day-of-week-picker__days-row', { hasError })}>
        {daysOfWeek.map(day => (
          <button
            key={day.value}
            type="button"
            className={withMods('day-of-week-picker__weekday-box', 'grid__item 1/7', { selected: valueMap[day.value] })}
            onClick={() => changeWeekdayBoxState(valueMap, onChange, day)}
            disabled={disabled}>
            <Message message={messages.dowShort} values={day} />
          </button>
        ))}
      </div>
      <InputError {...meta} />
    </div>
  );
};

DayOfWeekPicker.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.shape({
      Su: PropTypes.bool,
      Mo: PropTypes.bool,
      Tu: PropTypes.bool,
      We: PropTypes.bool,
      Th: PropTypes.bool,
      Fr: PropTypes.bool,
      Sa: PropTypes.bool,
    }),
  }),
  meta: reduxFormPropTypes.field.meta,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  startWeekOn: PropTypes.string,
};

export default DayOfWeekPicker;
